// removed by extract-text-webpack-plugin
module.exports = {"container":"_2Pw_xp76zKnRHdOnCBvfbY","title":"_3B0QCKnltFJaDcuSPuEGm6"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Pages/Admin/UserInformation/Signed/styles.css
// module id = 3168
// module chunks = 0